module.exports = __webpack_public_path__ + "shell/assets/brand/rgs/rancher-logo.svg";